import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Container, Tab, Tabs } from "react-bootstrap";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { PDFPreviewFile } from "../../../components/PDFFileHandler";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import CardDisplayComponent from "../../../components/CardDisplayComponent";

export default function PreviewCreatePlanPM() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  useEffect(() => {
    const key = state?.type
      ? `${state?.name}.${state?.type}`
      : state?.name || "create";
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        create: "สร้างแผน PM",
        working_plan: "กำหนดวันเข้าทำงาน PM แต่ละสาขา",
        work_order: {
          order: "สร้างใบสั่งงาน Service Request",
          ticket: "นำเข้าหมายเลขงานลูกค้า (Ticket No.)",
          request: "สร้างใบสั่งงาน Service Request"
        }
      }
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Add Create Plan PM Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="create" title="การสร้างแผน PM"></Tab>
          <Tab
            eventKey="working_plan"
            title="กำหนดแผนเข้าทำงาน PM แต่ละสาขา"
          ></Tab>
          <Tab eventKey="work_order" title="สร้างใบสั่งงาน Service Request">
            {websiteName === "สร้างใบสั่งงาน Service Request" && (
              <CardDisplayComponent
                header={{
                  title: {
                    className: "text-center",
                    text: "แสดงตัวอย่างใบสั่งงาน Service request"
                  }
                }}
                body={{ element: <PDFPreviewFile pdfFile={{}} /> }}
                footer={{
                  className: "text-center",
                  element: (
                    <Button
                      variant="outline-secondary"
                      className="px-5 py-2 text-dark rounded-pill"
                      onClick={() => navigate(-1)}
                    >
                      ย้อนกลับ
                    </Button>
                  )
                }}
              />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
